export const decryptToken = async (token, url) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    });

    if (!response.ok) {
      throw new Error('Failed to decrypt token');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error decrypting token:', error);
    throw error;
  }
};
